<template>
    <b-container fluid class="">
        <b-row class="">
            <b-col cols="12" md="12" class="w-100">
                <h3>{{$t('sales.users.event.title')}} - {{ event.name }} - {{ user.username }}</h3>
            </b-col>
        </b-row>

        <hr/>
        
        <b-container fluid class="">
        <b-row class="p-2 justify-content-center">
            <b-col cols="3" class="saleDash shadow-lg m-2 p-4">
            <b-row>
                <b-col cols="4">
                <i class="fas fa-chart-line fa-3x"></i>
                </b-col>
                <b-col cols="8">
                <b-card-title class="text-right">{{ $t('sales.users.event.sold')}}:</b-card-title>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="9">
                <b-card-text class="text-right">
                    <h3 v-if="eventAssignments.total_sold">{{ eventAssignments.total_sold }}</h3>
                    <h3 v-else>0</h3>
                </b-card-text>
                </b-col>
                <b-col cols="3">
                <b-card-text class="total">
                    <p style="color: #BCBCBC" v-if="eventAssignments.total">/{{ eventAssignments.total }}</p>
                    <p style="color: #BCBCBC" v-else>/0</p>
                </b-card-text>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                <b-progress height="1.5rem" class="w-100">
                     <b-progress-bar
                    :value="calculatePercentage(eventAssignments.total_sold,eventAssignments.total)"
                    :label="calculatePercentage(eventAssignments.total_sold,eventAssignments.total)+'%'"
                    ></b-progress-bar>
                </b-progress>
                </b-col>
            </b-row>
        </b-col>
        <b-col  cols="3" class="saleDash m-2 p-4">
            <b-row>
                <b-col cols="3">
                <i class="fas fa-cash-register fa-3x"></i>
                </b-col>
                <b-col cols="9">
                <b-card-title class="text-right">{{ $t('sales.users.event.profit')}}:</b-card-title>
                </b-col>
            </b-row>

            <b-card-text class="text-right">
                <h4>{{ totalProfit }} KM</h4>
            </b-card-text>
        </b-col>
        <b-col  cols="3" class="saleDash m-2 p-4">
          <b-row>
            <b-col cols="3">
              <i class="fas fa-tasks fa-2x"></i>
            </b-col>
            <b-col cols="9">
              <b-card-title class="text-right">{{ $t('sales.users.event.done')}}:</b-card-title>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="9">
              <b-card-text class="text-right">
                <h3 v-if="totalSold">{{ done }}</h3>
                <h3 v-else>0</h3>
              </b-card-text>
            </b-col>
            <b-col cols="3">
              <b-card-text class="total">
                <p style="color: #BCBCBC" v-if="totalAssigned">/{{ assignments.length }}</p>
                <p style="color: #BCBCBC" v-else>/0</p>
              </b-card-text>
            </b-col>
          </b-row>
      </b-col>
        </b-row>
        </b-container>
        <hr/>
        <b-container fluid class="">
        <b-row class="p-2 justify-content-center">
            <b-col cols="12" md="3" class="eventDash shadow-lg m-2 p-4" v-for="item in assignments" @click="goToAssignment(item.id)" v-b-popover.hover.right="$t('hover.msg')">
                <!-- <h5 class="text-center"> {{ item.name }} </h5>
                <h6>{{$t('sales.users.event.card.date')}}:  {{ item.created_at | moment('DD.MM.YYYY') }}  </h6>
                <hr style="background-color:#FFF;"/>
                <h6>{{$t('sales.users.event.card.tickets')}}: {{ item.total }} </h6>
                <h6>{{$t('sales.users.event.card.sold')}}: {{ item.total_sold }} </h6>
                <hr style="background-color:#FFF;"/>
                <h6>{{$t('sales.users.event.card.price')}}: {{ item.price }} KM</h6>
                <h6>{{$t('sales.users.event.card.profit')}}: {{ item.price * item.total_sold }} KM</h6> -->
                <b-row style="margin-bottom: 5%" >
                    <b-col cols="10">
                        <h6 class="text-left">{{ item.name.toUpperCase() }}</h6>
                    </b-col>
                    <b-col cols="2">
                        <span v-show="parseInt(item.total)>parseInt(item.total_sold)" class="flex-center">
                        </span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="9">
                        <p
                        style="color: #BCBCBC"
                        v-b-popover.hover.left="$t('sales.users.event.card.date')"
                        >{{ item.created_at | moment('DD.MM.YYYY') }}</p>
                    </b-col>
                    <b-col cols="3">
                        <span v-b-popover.hover.left="$t('sales.users.event.card.price')">{{ item.price }} KM</span>
                    </b-col>
                </b-row>
                <b-row>
                <b-col cols="9">
                    <b-row>
                    <b-col cols="1">
                        <b-card-text class="text-left">
                        <h3
                            v-b-popover.hover.left="$t('sales.users.event.card.sold')"
                        >{{ item.total_sold }}</h3>
                        </b-card-text>
                    </b-col>
                    <b-col cols="1">
                        <b-card-text class="text-left">
                        <p
                            style="color: #BCBCBC"
                            v-if="totalAssigned"
                            v-b-popover.hover.left="$t('sales.users.event.card.tickets')"
                        >/{{ item.total }}</p>
                        </b-card-text>
                    </b-col>
                    </b-row>
                </b-col>
                <b-col cols="3" style="color: #BCBCBC">
                    <p>{{calculatePercentage(item.total_sold,item.total)}} %</p>
                </b-col>
            </b-row>
            <b-row>
            <b-col cols="12">
                    <b-progress
                        height="1rem"
                        :value="calculatePercentage(item.total_sold,item.total)"
                        class="w-100"
                        ></b-progress>

                </b-col>
            </b-row>
            </b-col>
        </b-row>
        </b-container>

    
    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'dashboardEvent',
        data() {
            return {
                done: 0,
                event: {},
                eventAssignments: {
                    total: 0,
                    total_sold: 0
                },
                assignments: [],
                assignmentsFields: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'total',
                        label: 'Tickets assigned',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Date assigned',
                        sortable: true,
                        formatter: (value) => this.$moment(value).format("DD.MM.YYYY.")
                    },
                ],
            }
        },
         computed: {
            totalProfit() {
                if (this.assignments) {
                    let sum = 0;
                        this.assignments.forEach(function(item) {
                            sum += (parseFloat(item.price) * parseFloat(item.total_sold));
                        });
                    return sum;

                } else {
                    return 0;
                }
            },
            totalSold() {
                if (this.assignments) {
                    let sum = 0;
                    this.assignments.forEach(function(item) {
                    sum += parseInt(item.total_sold);
                    });
                    return sum;
                } else {
                    return 0;
                }
            },
            totalAssigned() {
                if (this.assignments) {
                    let sum = 0;
                    this.assignments.forEach(function(item) {
                    sum += parseInt(item.total);
                    });
                    return sum;
                } else {
                    return 0;
                }
            },
            user(){
                return this.$parent.currentUser;
            }
        },
        methods: {
            calculatePercentage(sold, total) {
                if (sold == 0 || total == 0) {
                    return 0;
                }
                if (parseInt((sold / total) * 100) === 100) {
                    //this.done++;
                }
                return parseInt((sold / total) * 100);
                },
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            goToAssignment(id){
                this.$router.push('/salesman/' +  this.$route.params.event_id + '/' + id)
            },
            getEvent(){
                this.$axios.get('/events/getById',
                {
                    params: {
                        id: this.$route.params.event_id,
                    }
                }
            ).then(response => {
                if (response.status === 200) {
                    this.event = response.data.data;
                }
            });
            },
            getAssignments(){
                var self = this;
                this.$axios.get('sales/userAssignments',{
                                params: {
                                    id: this.$parent.currentUser.id,
                                    event_id: this.$route.params.event_id
                                }
                            }).then(response => {
                if (response.status === 200) {
                    self.done = 0;
                    this.assignments = response.data.data;
                    this.assignments.forEach(assignment => {
                        if (assignment.total_sold / assignment.total === 1) {
                            self.done++;
                        }
                    });
                }
            })
            },
            getEventAssignment(){
                this.$axios.get('sales/userEvent',{
                                params: {
                                    event_id: this.$route.params.event_id,
                                    id: this.$parent.currentUser.id
                                }
                            }).then(response => {
                if (response.data.success) {
                    this.eventAssignments = response.data.data;
                }else{
                         this.$toasted.global.err({
                        message : this.$t(response.data.data.msg)
                            });
                    }          
            })
            },
        },
        created() {
            let self = this;
            this.getAssignments();
            this.getEvent();
            this.getEventAssignment();
            this.interval = setInterval(function () {
                self.getAssignments();
                self.getEventAssignment();
            }, 3000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>

<style  lang="scss">
    .sectorsRow{
        height: 30vh;
    }
    .sectorsRow2{
        height: 15vh;
    }

</style>